<template>
  <div class="demo_basic_config" :style="screenHeight" >
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <Tabs>
      <TabPane label="会话配置" name="8" :style="tanPaneHeight">
        <div class="input_style">
          <div class="font_style_set">关注公众号提示语:</div>
          <div class="bas_config_content">
            <Input placeholder="请输入关注公众号提示语" v-model = "subscribeWxTip">
              <Button slot="append" @click="paramerClick('1')" style="width: 100px;background-color: #2d8cf0;color: white;border-bottom-right-radius: 4px;border-top-right-radius: 4px">公众号名称</Button>
            </Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="访客关注接入的微信公众号时发送消息，仅微信公众号支持"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">欢迎语:</div>
          <div class="bas_config_content">
           <Input v-model="welcomeTip" name="欢迎语" placeholder="请输入欢迎语"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="会话开始时向访客发送消息"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">分配会话上限数:</div>
          <div class="bas_config_content">
            <Input style="width: 100%;" v-model="sessionUpperLimit" type="number" :number="true" @on-blur="checkNumber" name="分配会话上限数" placeholder="请输入分配会话上限数"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="支持在线客服的员工与访客会话的数量。0表示无限制，1表示一对一服务支持。当所有客服人员都达到最大支持会话数量后，新增访客将进入排队队列中。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">排队访客分配策略:</div>
          <div class="bas_config_content">
            <Select v-model="queueAllotStrategy">
              <Option v-for="(item, index) in queueAllotStrategyList" :value="item.value" :key="index">{{item.label}}</Option>
            </Select>
          </div>
          <Tooltip class="tips_font" placement="top" content="当在线客服员工有空闲时，队列中的访客以此分配策略分配给客服员工"><img :src="questionMark"/></Tooltip>
        </div>

        <div class="input_style">
          <div class="font_style_set">排队提示语:</div>
          <div class="bas_config_content">
            <Input placeholder="请输入排队提示语" v-model = "queueTip">
              <Button slot="append" @click="paramerClick('7')" style="width: 60px;background-color: #2d8cf0;color: white;border-bottom-right-radius: 4px;border-top-right-radius: 4px">总数</Button>
            </Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="当达到接待能力上限后，新访客自动进入排队状态，系统向访客发送提示语。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">分配提示语:</div>
          <div class="bas_config_content">
            <Input placeholder="请输入分配提示语" v-model = "allocateBroadcastTip">
              <Button slot="append" @click="paramerClick('3')" style="width: 60px;background-color: #2d8cf0;color: white;border-bottom-right-radius: 4px;border-top-right-radius: 4px">工号</Button>
            </Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="会话成功转到客服员工后，向访客发送消息"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style" style="display:none">
          <div class="font_style_set">黑名单提示语:</div>
          <div class="bas_config_content">
            <Input v-model="blackListTip" placeholder="请输入黑名单提示语"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="向黑名单访客发送提示语。"><img :src="questionMark"/></Tooltip>
        </div>

        <div class="input_style">
          <div class="font_style_set">访客无应答时长:</div>
          <div class="bas_config_content">
            <Input v-model="noAnswerDuration" type= "number" :number="true" @on-blur="checkNumber" name="访客无应答时间" placeholder="请输入访客无应答时间"><span slot="append">分钟</span></Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="座席客服向访客发送消息后，访客无应答时间设置。0表示不发送无应答提示语。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style" v-if="noAnswerDuration > 0">
          <div class="font_style_set">访客无应答提示语:</div>
          <div class="bas_config_content">
            <Input v-model="noAnswerTip" placeholder="请输入访客无应答提示语"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="员工向访客发送消息后，访客超过设定时间无应答发送的提示语。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">访客超时结束会话时长:</div>
          <div class="bas_config_content">
            <Input v-model="timeoutDuration" type= "number" :number="true" @on-blur="checkNumber" name="访客超时结束会话时间" placeholder="请输入访客超时结束会话时间"><span slot="append">分钟</span></Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="访客会话超时时间设置大于0时，表示超时结束会话。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style" v-if="timeoutDuration > 0">
          <div class="font_style_set">访客超时结束会话提示语:</div>
          <div class="bas_config_content">
            <Input v-model="timeoutTip" placeholder="请输入访客超时结束会话提示语"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="当超过访客会话超时时间访客端没有新消息产生，会向访客发送此提示语，并结束会话。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">员工无应答时长:</div>
          <div class="bas_config_content">
            <Input v-model="empTimeoutDuration" type= "number" :number="true" @on-blur="checkNumber" name="员工超时时间" placeholder="请输入员工超时时间"><span slot="append">分钟</span></Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="员工无应答时长"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style" v-if="empTimeoutDuration > 0">
          <div class="font_style_set">员工无应答提示语:</div>
          <div class="bas_config_content">
            <Input v-model="empTimeoutTip" placeholder="请输入员工无应答提示语"/>
          </div>
          <Tooltip class="tips_font" placement="top" content="员工无应答超过设置时间，向访客发送员工超时提示语。"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style">
          <div class="font_style_set">员工无应答转接时长:</div>
          <div class="bas_config_content">
            <Input v-model="empTimeoutTransferDuration" type= "number" :number="true" @on-blur="checkNumber" name="员工无应答转接时长" placeholder="请输入员工超时转接时间"><span slot="append">分钟</span></Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="员工收到消息无响应时间"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="input_style" v-if="empTimeoutTransferDuration > 0">
          <div class="font_style_set">员工无应答转接提示语:</div>
          <div class="bas_config_content">
            <Input placeholder="请输入员工无应答转接提示语" v-model = "empTimeoutTransferTip">
              <Button slot="append" @click="paramerClick('5')" style="width: 60px;background-color: #2d8cf0;color: white;border-bottom-right-radius: 4px;border-top-right-radius: 4px">工号</Button>
            </Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="当超过设置时间员工未应答，会发送此提示语并根据分配策略转接给其他员工。"><img :src="questionMark"/></Tooltip>
        </div>


        <div class="input_style" style="display:none">
          <div class="font_style_set">撤回消息时间:</div>
          <div class="bas_config_content">
            <Input v-model="withdrawMsgDuration" type= "number" :number="true" placeholder="请输入撤回消息时间"><span slot="append">分钟</span></Input>
          </div>
          <Tooltip class="tips_font" placement="top" content="员工或访客发送消息后，不超过此时间可以将消息撤回。默认时间2分钟。"><img :src="questionMark"/></Tooltip>
        </div>
      </TabPane>
    </Tabs>
    <div class="btn_template">
      <Button type="primary" class="submit_btn" v-if="roleList['3_12-5-1']" @click="save()">保存</Button>
      <Button type="primary" style="margin-right: 10px" class="search_btn reset_btn"  @click="reset()">重置</Button>
    </div>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "ParamConfig",
        mixins:[publicFunClass],
        props:{
          pageCode:String
        },
        data () {
          return {
            showPageCount:0,
            screenHeight:{height:''},
            tanPaneHeight:{height:''},
            questionMark:require('@/assets/image/homeAsk.png'),
            spinShow: true,
            sessionUpperLimit: 0, //会话上限
            queueAllotStrategy: '2',//排队访客分配策略
            queueAllotStrategyList: [{value:"1", label: "随机分配"},{value:"2", label: "等待时长最久分配"},{value:"3", label: "上次服务优先分配"}],//排队访客分配策略
            subscribeWxTip: '', //关注公众号提示语
            welcomeTip: '', //欢迎语
            allocateBroadcastTip: '', //分配播报工号提示语
            noAnswerDuration: 0, //访客无应答时间
            noAnswerTip:'', //访客无应答提示语
            timeoutDuration: 0, //超时结束会话时间
            timeoutTip:'', //超时结束会话提示语
            empTimeoutDuration: 0, //员工超时时间
            empTimeoutTip:'', //员工超时提示语
            empTimeoutTransferDuration: 0, //员工超时转接时间
            empTimeoutTransferTip: '', //员工超时转接提示语
            queueTip: '', //排队提示语
            blackListTip: '', //黑名单提示语
            withdrawMsgDuration: 2, //撤回消息时间
            tabValue: '8', //默认参数配置，
            configId: '',
            isUse: '1',
            roleList:JSON.parse(localStorage.getItem("roleList")),
          }
        },
      methods:{
        checkNumber: function (event) {
          let name = event.currentTarget.name;
          let value = event.currentTarget.value;
          let reg = /(^[0-9]\d*$)/;
          if (!reg.test(value)) {
            this.$Modal.info({
              title: '提示',
              content: name + "只能输入正整数"
            });
            event.currentTarget.value = 0;
            switch (name) {
              case '访客无应答时间':
                this.noAnswerDuration = 0;
                break;
              case '访客超时结束会话时间':
                this.timeoutDuration = 0;
                break;
              case '员工超时时间':
                this.empTimeoutDuration = 0;
                break;
              case '员工超时转接时间':
                this.empTimeoutTransferDuration = 0;
                break;
            }
            return false;
          }
        },
        save:function () {

          this.configValue={};
          if(this.tabValue=="8"){
            this.configValue["sessionUpperLimit"]=this.sessionUpperLimit;
            this.configValue["queueAllotStrategy"]=this.queueAllotStrategy;
            this.configValue["subscribeWxTip"]=this.subscribeWxTip;
            this.configValue["welcomeTip"]=this.welcomeTip;
            this.configValue["allocateBroadcastTip"]=this.allocateBroadcastTip;
            this.configValue["noAnswerDuration"]=this.noAnswerDuration;
            this.configValue["noAnswerTip"]=this.noAnswerTip;
            this.configValue["timeoutDuration"]=this.timeoutDuration;
            this.configValue["timeoutTip"]=this.timeoutTip;
            this.configValue["empTimeoutDuration"]=this.empTimeoutDuration;
            this.configValue["empTimeoutTip"]=this.empTimeoutTip;
            this.configValue["empTimeoutTransferDuration"]=this.empTimeoutTransferDuration;
            this.configValue["empTimeoutTransferTip"]=this.empTimeoutTransferTip;
            this.configValue["queueTip"]=this.queueTip;
            this.configValue["blackListTip"]=this.blackListTip;
            this.configValue["withdrawMsgDuration"]=this.withdrawMsgDuration;
          }

          let param={
            configValue:JSON. stringify(this.configValue),
            journalType:"参数配置=>保存",
            menuId:"3_12-5-1",
            type:this.tabValue,
            id:this.configId,
            isUse:this.isUse
          };
          let that=this;
          this.spinShow=true;
          this.$http.post("config/doSave.json",param) .then(function (res) {
            let result = res.data.flag;
            that.spinShow=false;
            if (result != "666") {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
              return false;
            }
            that.$Modal.info({
              title: '提示',
              content: "会话配置保存成功"
            });
            that.initPage();
          });
        },
        reset:function () {
            this.sessionUpperLimit = 0;//会话上限
            this.queueAllotStrategy = '2';//排队访客分配策略
            this.subscribeWxTip = ''; //关注公众号提示语
            this.welcomeTip = ''; //欢迎语
            this.allocateBroadcastTip=''; //分配播报工号提示语
            this.noAnswerDuration = 0; //访客无应答时间
            this.noAnswerTip = ''; //访客无应答提示语
            this.timeoutDuration= 0; //超时结束会话时间
            this.timeoutTip = ''; //超时结束会话提示语
            this.empTimeoutDuration = 0; //员工超时时间
            this. empTimeoutTip = ''; //员工超时提示语
            this.empTimeoutTransferDuration = 0; //员工超时转接时间
            this.empTimeoutTransferTip =''; //员工超时转接提示语
            this.queueTip = ''; //排队提示语
            this.blackListTip = ''; //黑名单提示语
            this.withdrawMsgDuration = 2; //撤回消息时间
        },

        initPage:function () {
          let that=this;
          let param={
            journalType:"null",
            menuId:"null",
            type:this.tabValue
          };
          this.spinShow=true;
          this.$http.post("config/selectConfig.json",param) .then(function (res) {
            let result = res.data.flag;
            that.spinShow=false;
            if (result != "666") {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
              return false;
            }
            that.configId='';
            let configJson = res.data.obj.configList;
            if(configJson && configJson.length > 0){
              that.configId = configJson[0].id;
              let config = JSON.parse(configJson[0].configValue);
              that.sessionUpperLimit = config.sessionUpperLimit;//会话上限
              that.queueAllotStrategy = config.queueAllotStrategy;//排队访客分配策略
              that.subscribeWxTip = config.subscribeWxTip; //关注公众号提示语
              that.welcomeTip = config.welcomeTip; //欢迎语
              that.allocateBroadcastTip= config.allocateBroadcastTip; //分配播报工号提示语
              that.noAnswerDuration = config.noAnswerDuration; //访客无应答时间
              that.noAnswerTip = config.noAnswerTip; //访客无应答提示语
              that.timeoutDuration= config.timeoutDuration; //超时结束会话时间
              that.timeoutTip = config.timeoutTip; //超时结束会话提示语
              that.empTimeoutDuration = config.empTimeoutDuration; //员工超时时间
              that.empTimeoutTip = config.empTimeoutTip; //员工超时提示语
              that.empTimeoutTransferDuration = config.empTimeoutTransferDuration; //员工超时转接时间
              that.empTimeoutTransferTip = config.empTimeoutTransferTip; //员工超时转接提示语
              that.queueTip = config.queueTip; //排队提示语
              that.blackListTip = config.blackListTip; //黑名单提示语
              that.withdrawMsgDuration = config.withdrawMsgDuration; //撤回消息时间
            }
          });
      },
        // 页面参数点击
        paramerClick: function(type){
            if(type == "1"){
                this.subscribeWxTip = this.subscribeWxTip + "{WXNAME}";
            }else if(type == "2"){
                this.allocateBroadcastTip = this.allocateBroadcastTip + "{AGENTNAME}";
            }else if(type == "3"){
                this.allocateBroadcastTip = this.allocateBroadcastTip + "{AGENTNUMBER}";
            }else if(type == "4"){
                this.empTimeoutTransferTip = this.empTimeoutTransferTip + "{AGENTNAME}";
            }else if(type == "5"){
                this.empTimeoutTransferTip = this.empTimeoutTransferTip + "{AGENTNUMBER}";
            }else if(type == "6"){
                this.queueTip = this.queueTip + "{QUEUENO}";
            }else if(type == "7"){
                this.queueTip = this.queueTip + "{QUEUENUMBER}";
            }
        },
      },
      created(){
        this.screenHeight.height=this.mountHeight(133);
        this.tanPaneHeight.height=this.mountHeight(200);
        this.initPage();
      }
    }
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/systemSetup/paramConfig.vue